module.exports = __webpack_public_path__ + "img/lt.fc55cd5c.png";